let activeLenis = null;
let locks = 0;

// Fast start, long soft landing: section jumps feel immediate but never abrupt
const easeOutExpo = (t) => (t === 1 ? 1 : 1 - 2 ** (-10 * t));

export function setLenis(instance) {
  activeLenis = instance;
  if (locks) activeLenis?.stop();
}

export function scrollToSection(id, options = {}) {
  const target = document.getElementById(id);
  if (!target) return;
  const immediate = window.matchMedia('(prefers-reduced-motion: reduce)').matches || options.immediate;
  if (activeLenis && !locks) {
    activeLenis.scrollTo(target, { offset: -72, immediate, duration: 0.9, easing: easeOutExpo });
  } else {
    target.scrollIntoView({ behavior: immediate ? 'auto' : 'smooth', block: 'start' });
  }
}

export function scrollToTop() {
  if (activeLenis && !locks) activeLenis.scrollTo(0, { immediate: true });
  else window.scrollTo(0, 0);
}

export function lockStoryScroll() {
  locks += 1;
  activeLenis?.stop();
  return () => {
    locks = Math.max(0, locks - 1);
    if (!locks) activeLenis?.start();
  };
}
